import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import retardUpdate from '../../../../lib/react/update-retarder';
import OEResizeObserver from '../../../../lib/components/oe-resize-observer';
import {OETargetMenu} from '../../../elements/target-menu/oe-target-menu';
import {OEStdCapBarLayoutType, OEStdCapBarPropTypes} from './oe-std-cap-bar-model';
import OEStdCapBarBare from './oe-std-cap-bar-bare';
import OEStdCapBarTargetTypeBar from './oe-std-cap-bar-target-type-bar';
import OEStdCapBarTargetBar from './oe-std-cap-bar-target-bar';
import OEToolbox from '../../../../lib/tools/oe-toolbox';

export default class OEStdTargetBarCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.connectFlag = false;

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.unitSize = 16;

        this.state = {
            layoutType: OEStdCapBarLayoutType.min,
        };

        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);
        
        this.onWindowResized = this.onWindowResized.bind(this);

        this.onMiddleResize = this.onMiddleResize.bind(this);
        this.onUnitSizeResize = this.onUnitSizeResize.bind(this);
        this.onTargetTitleResize = this.onTargetTitleResize.bind(this);
        this.onTargetLabelResize = this.onTargetLabelResize.bind(this);
        this.onTargetMenuResize = this.onTargetMenuResize.bind(this);
        this.onTargetTypeBarContentResize = this.onTargetTypeBarContentResize.bind(this);

        this.onTargetMenuRef = this.onTargetMenuRef.bind(this);
        this.onMiddleRef = this.onMiddleRef.bind(this);
        this.onTargetTypeBarContentRef = this.onTargetTypeBarContentRef.bind(this);

        this.onTargetMenuToggle = this.onTargetMenuToggle.bind(this);
    }

    componentDidMount()    {
        this.onWindowResized();
        window.addEventListener('resize', this.onWindowResized);
    }

    componentWillUnmount()    {
        window.removeEventListener('resize', this.onWindowResized);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    updateLayout()  {
        if(!this.connectFlag)   return;
        
        if(!this.middleRef || !this.targetTypeBarContentRef) {
            this.setState({layoutType: OEStdCapBarLayoutType.singleRow});
            return;
        }

        const unitScale = this.unitSize ? this.unitSize / 16 : 1;

        if(!this.targetTitleSize)   this.targetTitleSize = {w: 0, h: 0};
        if(!this.targetLabelSize)   this.targetLabelSize = {w: 0, h: 0};
        if(!this.targetMenuSize)   this.targetMenuSize = {w: 0, h: 0};

        const middleWidth = $(this.middleRef).outerWidth();
        const targetTypeBarContentWidth = $(this.targetTypeBarContentRef).outerWidth();
        const targetBarContentWidth = this.targetTitleSize.w + this.targetLabelSize.w + this.targetMenuSize.w;

        const targetTitlePaddingComp = {
            toSingle: this.state.layoutType === OEStdCapBarLayoutType.singleRow ? 0 : 24 * unitScale,
            toMulti: this.state.layoutType === OEStdCapBarLayoutType.singleRow ? -24 * unitScale : 0
        };

        let layoutType = OEStdCapBarLayoutType.singleRow;
        if(targetBarContentWidth + targetTitlePaddingComp.toMulti > middleWidth - 16 * unitScale) {
            layoutType = OEStdCapBarLayoutType.threeRow;
        } else if(targetBarContentWidth + targetTitlePaddingComp.toSingle + 4 * unitScale >= 0.5 * (middleWidth - targetTypeBarContentWidth))  {
            layoutType = OEStdCapBarLayoutType.twoRow;
        }

        //console.log('layoutType: ' + layoutType);
        this.setState({layoutType: layoutType});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.compControllerWasVisible = false;
            return;
        }

        this.connectFlag = true;

        this.compControllerWasVisible = false;
        
        retardUpdate(this, () => {
            this.updateLayout();
        });
    }

    onUIControllerStateChanged(message, userInfo)   {
        if(userInfo.type === this.oe.Module.UIControllerType.component && userInfo.visible) {
            this.compControllerWasVisible = false;
            if(this.targetMenuRef) this.targetMenuRef.setOpen(false);
        }
    }

    onWindowResized()   {
        this.updateLayout();
    }

    onMiddleResize(sender, size)    {
        this.updateLayout();
    }

    onUnitSizeResize(sender, size)   {
        if(this.unitSize === size.w) return;
        this.unitSize = size.w;
        this.updateLayout();
    }

    onTargetTitleResize(sender, size)  {
        if(OEToolbox.shallowEqual(this.targetTitleSize, size)) return;
        this.targetTitleSize = size;
        this.updateLayout();
    }

    onTargetLabelResize(sender, size)  {
        if(OEToolbox.shallowEqual(this.targetLabelSize, size)) return;
        this.targetLabelSize = size;
        this.updateLayout();
    }

    onTargetMenuResize(sender, size)  {
        if(OEToolbox.shallowEqual(this.targetMenuSize, size)) return;
        this.targetMenuSize = size;
        this.updateLayout();
    }

    onTargetTypeBarContentResize(sender, size)   {
        this.setState({targetTypeBarWidth: size.w});
        this.updateLayout();
    }

    onTargetMenuRef(ref)    {
        this.targetMenuRef = ref;
    }

    onMiddleRef(ref)   {
        if(this.middleRef === ref) return;
        this.middleRef = ref;
        this.updateLayout();
    }

    onTargetTypeBarContentRef(ref) {
        if(this.targetTypeBarContentRef === ref) return;
        this.targetTypeBarContentRef = ref;
        this.updateLayout();
    }

    render() {
        const layoutType = this.state.layoutType === OEStdCapBarLayoutType.min ? OEStdCapBarLayoutType.singleRow : this.state.layoutType;
        
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <OEStdCapBarBare
                    className={'std-target-bar-cap-bar ' + this.props.className + ((layoutType === OEStdCapBarLayoutType.singleRow ? ' ' : ' multi-row ') + layoutType)}
                    appComponent={this.props.appComponent}
                    showMainMenuControlBtn={this.props.showMainMenuControlBtn}
                    showFullscreenBtn={this.props.showFullscreenBtn}
                    isFullscreen={this.props.isFullscreen}
                    middleElementRef={this.onMiddleRef}
                    onMiddleResize={this.onMiddleResize}
                >

                    <OEResizeObserver className="unit-size-observer" onResize={this.onUnitSizeResize}/>

                    <OEStdCapBarTargetBar
                        style={layoutType === OEStdCapBarLayoutType.singleRow && this.state.targetTypeBarWidth ? {width: 'calc(50% - ' + (0.5 * this.state.targetTypeBarWidth).toString() + 'px)'} : null}
                        moduleId={this.props.moduleId}
                        disabled={this.props.disabled}
                        empty={this.state.layoutType === OEStdCapBarLayoutType.min}
                        layoutType={layoutType}
                        title={this.props.targetBarTitle}
                        label={this.props.targetBarLabel}
                        button={this.props.targetBarButton}
                        targetMenuEntries={this.props.targetMenuEntries}
                        targetMenuDisabled={this.props.targetMenuDisabled}
                        targetMenuHidden={this.props.targetMenuHidden}
                        onTargetMenuToggle={this.onTargetMenuToggle}
                        onTargetMenuDisabledToggle={this.props.onTargetMenuDisabledToggle}
                        onTargetTitleResize={this.onTargetTitleResize}
                        onTargetLabelResize={this.onTargetLabelResize}
                        onTargetMenuResize={this.onTargetMenuResize}
                        targetMenuRef={this.onTargetMenuRef}
                    />

                    <OEStdCapBarTargetTypeBar
                        style={layoutType === OEStdCapBarLayoutType.singleRow && this.state.targetTypeBarWidth ? {left: 'calc(50% - ' + (0.5 * this.state.targetTypeBarWidth).toString() + 'px)'} : null}
                        disabled={this.props.disabled}
                        buttons={this.props.targetTypeBar}
                        leftSpacer={layoutType !== OEStdCapBarLayoutType.singleRow}
                        rightSpacer={true}
                        contentElementRef={this.onTargetTypeBarContentRef}
                        onContentResize={this.onTargetTypeBarContentResize}
                    />
                    
                </OEStdCapBarBare>
            </React.Fragment>
        );
    }

    onTargetMenuToggle(isOpen)    {
        if(!this.oe.isReady()) return;
        if(!isOpen) {   // going to open
            this.compControllerWasVisible = this.oe.sharedInterface.getUIControllerVisible(this.oe.Module.UIControllerType.component);
            this.oe.sharedInterface.setUIControllerVisible(false, this.oe.Module.UIControllerType.component);
        } else {    // going to close
            if(this.compControllerWasVisible)   this.oe.sharedInterface.setUIControllerVisible(true, this.oe.Module.UIControllerType.component);
            this.compControllerWasVisible = false;
        }
    }
}

OEStdTargetBarCapBar.defaultProps = {
    className:                      '',
    moduleId:                       '',
    disabled:                       false,
    showMainMenuControlBtn:         true,
    showFullscreenBtn:              true,
    isFullscreen:                   false,
    targetTypeBar:                  [],
    targetMenuDisabled:             false,
    targetMenuHidden:               false
};

OEStdTargetBarCapBar.propTypes = {
    className:                      PropTypes.string,
    moduleId:                       PropTypes.string,
    disabled:                       PropTypes.bool,
    showMainMenuControlBtn:         PropTypes.bool,
    showFullscreenBtn:              PropTypes.bool,
    isFullscreen:                   PropTypes.bool,
    appComponent:                   PropTypes.object,
    targetTypeBar:                  PropTypes.arrayOf(OEStdCapBarPropTypes.targetTypeButton),
    targetBarTitle:                 PropTypes.string,
    targetBarLabel:                 PropTypes.string,
    targetBarButton:                OEStdCapBarPropTypes.targetBarButton,
    targetMenuEntries:              OETargetMenu.propTypes.entries,
    targetMenuDisabled:             PropTypes.bool,
    targetMenuHidden:               PropTypes.bool,
    onTargetMenuDisabledToggle:     PropTypes.func
};